<ng-template let-modal #modaPlanInvalid>
    <div class="modal-body ps-5">
        <div class="warning-message text-center text-purple">{{ plansService.titlePlanInvalid$ | async }}</div>
        <div class="flex flex-column mt-5 justify-content-center">
            <div class="">Con el plan estándar tendrás acceso inmediato a:</div>
            <ul class="ms-5">
                <li *ngFor="let text of plansService.recommendationsMessages$ | async" class="mt-3">{{ text }}</li>
            </ul>
        </div>
    </div>
    <div class="modal-footer border-top-0 mt-5">
        <div class="box-btn-cancel">
            <button class="btn btn-confirm btn-purple" type="button" (click)="goTo('/dashboard')">Ir al Home</button>
        </div>
        <div class="box-btn-cancel">
            <button class="btn btn-cancel" type="button" (click)="goTo('/comercio/plans')">Mejorar plan</button>
        </div>
    </div>
</ng-template>
